module.exports = __webpack_public_path__ + "static/media/9.cd023760.svg";